import { languages } from "./languages";

export default {
  points: {
    id: "points",
    label: languages.tiebreakers.points,
    label_sets: languages.tiebreakers.pointsSets,
  },
  goalDifference: {
    id: "goalDifference",
    label: languages.tiebreakers.goalDifference,
    label_sets: languages.tiebreakers.pointsDifference,
  },
  pointsRatio: {
    id: "pointsRatio",
    label: languages.tiebreakers.pointsRatio,
    sets: true,
  },
  goalsScored: {
    id: "goalsScored",
    label: languages.tiebreakers.goalsScored,
    label_sets: languages.tiebreakers.pointsScored,
  },
  headToHead: {
    id: "headToHead",
    label: languages.tiebreakers.headToHead,
    subCriteria: true,
  },
  numMatchesWon: {
    id: "numMatchesWon",
    label: languages.tiebreakers.matchesWon,
  },
  setDifference: {
    id: "setDifference",
    label: languages.tiebreakers.setDifference,
    sets: true,
  },
  setRatio: {
    id: "setRatio",
    label: languages.tiebreakers.setRatio,
    sets: true,
  },
  numSetsWon: {
    id: "numSetsWon",
    label: languages.tiebreakers.setsWon,
    sets: true,
  },
  pointsAverage: {
    id: "pointsAverage",
    label: languages.tiebreakers.pointsAverage,
    label_sets: languages.tiebreakers.pointsAverageSets,
  },
  goalsConceded: {
    id: "goalsConceded",
    label: languages.tiebreakers.goalsConceded,
    label_sets: languages.tiebreakers.pointsConceded,
  },
  cleanSheets: {
    id: "cleanSheets",
    label: languages.tiebreakers.cleanSheets,
    label_sets: languages.tiebreakers.cleanSheetsSets,
  },
};
